import { render, staticRenderFns } from "./ArtifactStatsCard.vue?vue&type=template&id=61597c7a&scoped=true&"
import script from "./ArtifactStatsCard.vue?vue&type=script&lang=js&"
export * from "./ArtifactStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactStatsCard.vue?vue&type=style&index=0&id=61597c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61597c7a",
  null
  
)

export default component.exports